import { render, staticRenderFns } from "./LeadStatusesPage.vue?vue&type=template&id=17869ab0&"
import script from "./LeadStatusesPage.vue?vue&type=script&lang=js&"
export * from "./LeadStatusesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports